import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Typography,
  Box,
  Grid,
  Switch,
} from "@mui/material";
import { Star } from "@mui/icons-material";

const EnhancedTopPerformers = ({ data }) => {
  const [isAgent, setIsAgent] = useState(false);
  const [isPayout, setIsPayout] = useState(false);

  const performers = isPayout
    ? isAgent
      ? data.topAgentsForPayout
      : data.topMerchantsForPayout
    : isAgent
    ? data.topAgentsForPayin
    : data.topMerchantsForPayin;
  return (
    <Box sx={{ p: 0, maxWidth: 800, mx: "auto", height: "500px" }}>
      <Card sx={{ boxShadow: 1, borderRadius: 4 }} className="h-100">
        <CardHeader
          sx={{ paddingBottom: "0px" }}
          title={
            <>
              <div className="d-flex flex-column flex-md-row justify-content-between">
                <div>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      background: "linear-gradient(to right, #424242, #212121)",
                      WebkitBackgroundClip: "text",
                      alignSelf: "center",
                      fontWeight: "600",
                      color: "#495a69",
                      marginTop:"15px"
                    }}
                  >
                    Top Performer
                  </Typography>
                  <p className="text-muted mt-1 d-flex align-items-center mb-0" style={{ fontSize: "11px", color: "#495a69" }}><Star sx={{ fontSize: 18, color: "#495a69" }} /><span>last 24 hour data</span></p>
                </div>
                <div className="d-flex gap-4">
                  <div className="d-flex align-items-center">
                    <span style={{ fontSize: "12px", color: "#495a69" }}>
                      Merchant
                    </span>
                    <Switch
                      checked={isAgent}
                      onChange={() => setIsAgent(!isAgent)}
                      color="primary"
                    />
                    <span style={{ fontSize: "12px", color: "#495a69" }}>
                      Agent
                    </span>
                  </div>
                  <div
                    className="d-flex align-items-center"
                    style={{ float: "right", marginLeft: "10px" }}
                  >
                    <span style={{ fontSize: "12px", color: "#495a69" }}>
                      PayIn
                    </span>
                    <Switch
                      checked={isPayout}
                      onChange={() => setIsPayout(!isPayout)}
                      color="primary"
                    />
                    <span style={{ fontSize: "12px", color: "#495a69" }}>
                      Payout
                    </span>
                  </div>
                </div>
              </div>
            </>
          }
        />
        <CardContent className="top-performer-block mt-4">
          <Grid container spacing={1.7}>
            {performers && performers.length > 0 ? (
              performers.map((performer, index) => (
                <Grid
                  item
                  xs={12}
                  key={performer.performer_id}
                  sx={{ padding: "1px" }}
                >
                  <Card
                    sx={{
                      p: "3px",
                      borderRadius: 2,
                      boxShadow: 1,
                      transition: "all 0.3s ease",
                      "&:hover": { boxShadow: 4 },
                    }}
                  >
                    <div
                      className="d-flex items-center"
                      style={{
                        padding: "10px 15px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="d-flex" style={{ position: "relative" }}>
                        <Avatar
                          alt={performer.performer_name}
                          sx={{
                            width: 28,
                            height: 28,
                            border: 2,
                            borderColor: "common.white",
                            boxShadow: 2,
                            fontSize: "12px",
                            background: "#495a69",
                          }}
                        >
                          {performer.performer_name[0]}
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: "6px",
                            alignSelf: "center",
                            fontSize: "12.5px",
                            color: "#495a69",
                          }}
                        >
                          {performer.performer_name}
                        </Typography>
                      </div>
                      <div className="d-flex">
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            color: "#495A69",
                          }}
                        >
                          ₹{performer.total_amount.toLocaleString()}
                        </Typography>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={0.5}
                          sx={{ marginLeft: "18px" }}
                        >
                          <Star sx={{ fontSize: 20, color: "#6ac2caf5" }} />
                          <Typography variant="body2" color="text.secondary">
                            {index + 1}
                          </Typography>
                        </Box>
                      </div>
                    </div>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: "center",
                  width: "100%",
                  padding: "10px",
                  height: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No data available
              </Typography>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EnhancedTopPerformers;
